import { Video } from 'api';
import { VideoData } from 'lib/pages/talks/slug/[...slug].props';
import { useRouter } from 'next/router';
import { getParentUrl } from '../utils';

interface PlayerMetadataProps {
  video: VideoData;
  isEmbed: boolean;
  shouldAutoplay: boolean | undefined;
  startTime: number | null;
  poster: string;
  userId: string;
  mixpanelDistinctId: string | null;
  hasAds: boolean;
  adProps: {
    adStreamId: string | undefined;
  };
  playerTalkData: Video['acmePlayerData'];
}

export function usePlayerMetadata({
  video,
  isEmbed,
  shouldAutoplay,
  startTime,
  poster,
  userId,
  mixpanelDistinctId,
  hasAds,
  adProps,
  playerTalkData
}: PlayerMetadataProps) {
  const router = useRouter();
  const { partner } = router.query;

  return {
    player_name: `Zenith HLS Mux Player ${isEmbed ? '(Embed)' : '(Internal)'}`,
    page_type: isEmbed ? 'iframe' : 'watchpage',
    player_autoplay_on: shouldAutoplay,
    player_init_time: startTime ?? 0,
    video_poster_url: poster,
    video_id: video?.id,
    video_title: video?.slug ?? video?.title,
    video_duration: video?.duration,
    video_language_code: router.query?.lang as string,
    video_encoding_variant:
      playerTalkData?.resources?.hls?.stream?.indexOf('manifest.m3u8') > -1
        ? 'consus'
        : 'symfony',
    video_stream_type: 'on-demand',
    video_variant_id: adProps?.adStreamId ?? 'none',
    viewer_user_id: userId,
    sub_property_id: isEmbed ? 'embed' : 'zenith',
    custom_1: mixpanelDistinctId ?? 'unknown',
    custom_2: partner as string,
    view_has_ad: hasAds,
    ...(hasAds && {
      video_variant_name: 'DAI Stream',
      video_variant_id: adProps?.adStreamId
    }),
    ...(isEmbed && {
      custom_3: getParentUrl() ?? '',
      custom_4: getParentUrl() ? new URL(getParentUrl() as string).hostname : ''
    })
  };
}
